import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const RegisterFormPhoneVerificationInfo = () => {
    return (
        <div className={phoneInfoStyle}>
            <InfoIcon size="1.6" wrapperSize="1.6" />
            <Text variant="info_txt_2" color="var(--colors-secondary)" className={textStyle}>
                Na podany numer wyślemy SMS z kodem weryfikacyjnym.
            </Text>
        </div>
    );
};

const phoneInfoStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: "var(--colors-background-200)",
    mt: -1,
    pt: 1.5,
    pb: 0.5,
    px: 1,
    borderBottomRadius: 1
});

const textStyle = css({
    display: "flex",
    alignItems: "center",
    height: "1.6rem"
});
import {css} from "@panda/css";

import {InfoIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

export const RegisterFormPhoneVerificationInfo = () => {
    return (
        <div className={phoneInfoStyle}>
            <InfoIcon size="1.6" wrapperSize="1.6" />
            <Text variant="info_txt_2" color="var(--colors-secondary)" className={textStyle}>
                Na podany numer wyślemy SMS z kodem weryfikacyjnym.
            </Text>
        </div>
    );
};

const phoneInfoStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: "var(--colors-background-200)",
    mt: -1,
    pt: 1.5,
    pb: 0.5,
    px: 1,
    borderBottomRadius: 1
});

const textStyle = css({
    display: "flex",
    alignItems: "center",
    height: "1.6rem"
});
